import { AuthenticationContainer, StyledLoginFormContainer } from "../../components";
import type { AuthenticationRequestData } from "../../schemas";

import { LoginForm } from "./login-form";

export interface LoginTemplateProps {
	readonly onSubmit: (data: AuthenticationRequestData) => void;
	readonly defaultUsername: string;
	readonly isSubmitting: boolean;
	readonly isSsoError: boolean;
}

export const LoginTemplate: React.FC<LoginTemplateProps> = ({
	onSubmit,
	isSubmitting,
	isSsoError,
	defaultUsername,
}) => {
	return (
		<AuthenticationContainer>
			<StyledLoginFormContainer maxWidth="sm">
				<LoginForm
					onSubmit={onSubmit}
					isSubmitting={isSubmitting}
					isSsoError={isSsoError}
					defaultUsername={defaultUsername}
				/>
			</StyledLoginFormContainer>
		</AuthenticationContainer>
	);
};
